<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Rutas</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Rutas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="muestraModalAgrega(); showModalAgregar()" size="sm"
        mdbWavesEffect>
        Agregar
      </button>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="1" mdbInput />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
          <label class="form-check-label" for="materialInline2">Inactivos</label>
        </div>

        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
      </div>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn type="button" (click)="filtraxEstado()" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Descripción</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ruta of rutaList">
            <td>{{ ruta.codigo }}</td>
            <td>{{ ruta.descripcion }}</td>
            <td>
              <div *ngIf="ruta.estado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!ruta.estado">
                <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#basicExamplex" (click)="showModalModificar(); showForEdit(ruta)"
                mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
              <button *ngIf="!ruta.estado" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(ruta)" mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="ruta.estado" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(ruta)" mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>




<div mdbModal #centralLarge="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formAgregarRuta">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Agregar
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLarge.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos de ruta
                </h5>
                <div class="md-form">
                  <input value="" type="text" id="codigo" class="form-control" placeholder="Código" maxLength="6"
                    required #codigo formControlName="codigo" />
                  <label for="codigo">Código <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                    frmAgregaCodigo.invalid &&
                    (frmAgregaCodigo.dirty || frmAgregaCodigo.touched)
                  ">
                    <mdb-error *ngIf="frmAgregaCodigo.errors.required">
                      El código es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaCodigo.errors.maxlength">
                      El código no puede superar los 6 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaCodigo.errors.minlength">
                      El código debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>

                <div class="md-form">
                  <input value="" type="text" id="descripcion" class="form-control" placeholder="Descripcion"
                    maxLength="50" required #descripcion formControlName="descripcion" />
                  <label for="descripcion">Descripción <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                    frmAgregaDescripcion.invalid &&
                    (frmAgregaDescripcion.dirty ||
                      frmAgregaDescripcion.touched)
                  ">
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.required">
                      La descripción es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.maxlength">
                      La descripción no puede superar los 50 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.minlength">
                      La descripción debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estado" formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLarge.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="!formAgregarRuta.valid"
            (click)="ValidaQueExisteDatosRuta(); centralLarge.hide()">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div mdbModal #centralLargex="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formEditarRuta">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Modificar Rutas
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLargex.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="acodigox" class="form-control" placeholder="Código" maxLength="6"
                    #codigox formControlName="codigo" />
                  <label for="codigox">Código <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                    frmEditarCodigo.invalid &&
                    (frmEditarCodigo.dirty || frmEditarCodigo.touched)
                  ">
                    <mdb-error *ngIf="frmEditarCodigo.errors.required">
                      El código es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarCodigo.errors.maxlength">
                      El código no puede superar los 6 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarCodigo.errors.minlength">
                      El código debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>

                <div class="md-form">
                  <input id="codigox" class="form-control" type="hidden" #codigox formControlName="codigo" />
                  <input id="rut_empresax" class="form-control" type="hidden" formControlName="rut_empresa" />
                  <input id="sucursal_codigox" class="form-control" type="hidden" formControlName="sucursal_codigo" />
                </div>

                <div class="md-form">
                  <input type="text" id="descripcionx" class="form-control" formControlName="descripcion" maxLength="50"
                    #descripcionx />
                  <label for="descripcionx">Descripción <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                    frmEditarDescripcion.invalid &&
                    (frmEditarDescripcion.dirty ||
                      frmEditarDescripcion.touched)
                  ">
                    <mdb-error *ngIf="frmEditarDescripcion.errors.required">
                      La descripción es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarDescripcion.errors.maxlength">
                      La descripción no puede superar los 50 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarDescripcion.errors.minlength">
                      La descripción debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estadox"
                      formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLargex.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="!formEditarRuta.valid"
            (click)="actualizar(); centralLargex.hide()">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>